"use strict";
const isEscape = (event) => event.key === "Escape";
const isArrowLeft = (event) => event.key === "ArrowLeft";
const isArrowUp = (event) => event.key === "ArrowUp";
const isArrowRight = (event) => event.key === "ArrowRight";
const isArrowDown = (event) => event.key === "ArrowDown";
const isBackspace = (event) => event.key === "Backspace";
const isDelete = (event) => event.key === "Delete";
export {
  isArrowDown,
  isArrowLeft,
  isArrowRight,
  isArrowUp,
  isBackspace,
  isDelete,
  isEscape
};
